/* @SH: Has customisations */

import { EVENTS, subscribe } from '@archetype-themes/utils/pubsub'

class BlockPrice extends HTMLElement {
  connectedCallback() {
    this.variantChangeUnsubscriber = subscribe(
      `${EVENTS.variantChange}:${this.dataset.productId}`,
      this.handleVariantChange.bind(this)
    )

    // @SH: Added a subscription to a variant changing event
    this.shVariantChangingUnsubscriber = subscribe(
      `${EVENTS.shVariantChanging}:${this.dataset.productId}`,
      this.shHandlerVariantChanging.bind(this)
    )
    // /@SH
  }

  disconnectedCallback() {
    this.variantChangeUnsubscriber()
    // @SH: Clean up changing event
    this.shVariantChangingUnsubscriber()
    // /@SH
  }

  handleVariantChange({ detail }) {
    // @SH: Remove loading class
    this.classList.remove('unload');
    // /@SH

    const { html, variant } = detail

    if (!variant) {
      return
    }

    const priceSource = html.querySelector(`block-price[data-section-id="${this.dataset.sectionId}"] div`)
    const priceDestination = this.querySelector('div')

    if (priceSource && priceDestination) {
      priceDestination.outerHTML = priceSource.outerHTML
    }

    // @SH: Change variant title, if exists
    const variantTitleSource = html.querySelector(`block-price[data-section-id="${this.dataset.sectionId}"] [data-selected-option-name]`);
    const variantTitleDestination = this.querySelector('[data-selected-option-name]');

    if (variantTitleSource && variantTitleDestination) {
      variantTitleDestination.outerHTML = variantTitleSource.outerHTML
    }
    // /@SH

    // @SH: Change pay later badges, if exists
    const payLaterSource = html.querySelector(`block-price[data-section-id="${this.dataset.sectionId}"] .product__pay-later-holder`);
    const payLaterDestination = this.querySelector('.product__pay-later-holder');

    if (payLaterSource && payLaterDestination) {
      payLaterDestination.outerHTML = payLaterSource.outerHTML
    }
    // /@SH
  }

  // @SH: Handler for changing event
  shHandlerVariantChanging() {
    this.classList.add('unload');
  }
  // @SH
}

customElements.define('block-price', BlockPrice)
